// CLASSES
import AppConfig from "@classes/AppConfig";
import ProductPurchase2 from "./ProductPurchase2";


export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	if (state.fields.checkbox_autogiro_single.checked && state.fields.customer_autogiro_single_amount <= 0) {
		return false;
	}

	if (state.fields.checkbox_autogiro_monthly.checked && state.fields.customer_autogiro_monthly_amount <= 0) {
		return false;
	}

	if (state.fields.checkbox_autogiro_single.checked &&
		state.fields.customer_autogiro_single_amount &&
		state.fields.customer_autogiro_single_amount > 0) {
		if (state.fields.customer_autogiro_single_amount < ProductPurchase2.minimumAmountSingleDeposit) {
			return false;
		}

		if (state.autogiroSingleFundsSharesTotal !== 100) {
			return false;
		}

		/**
		 * For each of active funds, loop and check that isin value is set
		 */
		for (let i = 0; i < state.autogiroSingleFundsActive; i++) {
			const fund = state.fields.customer_autogiro_single_funds[i];
			if (fund["customer_autogiro_single_fund_" + (i + 1) + "_name"] === "" ||
				fund["customer_autogiro_single_fund_" + (i + 1) + "_isin"] === "") {
				return false;
			}
		}
	}

	if (state.fields.checkbox_autogiro_monthly.checked &&
		state.fields.customer_autogiro_monthly_amount &&
		state.fields.customer_autogiro_monthly_amount > 0) {

		if (state.fields.customer_autogiro_monthly_amount < ProductPurchase2.minimumAmountMonthlyDeposit) {
			return false;
		}

		if (state.autogiroMonthlyFundsSharesTotal !== 100) {
			return false;
		}

		/**
		 * For each of active funds, loop and check that isin value is set
		 */
		for (let i = 0; i < state.autogiroMonthlyFundsActive; i++) {
			const fund = state.fields.customer_autogiro_monthly_funds[i];
			if (fund["customer_autogiro_monthly_fund_" + (i + 1) + "_name"] === "" ||
				fund["customer_autogiro_monthly_fund_" + (i + 1) + "_isin"] === "") {
				return false;
			}
		}
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/ProductPurchase-2/alfakraft/ProductPurchase2.fulfillment.js